<template>
  <div class="bg-nosotros-numeros" style="background-color: #ececee">
    <div class="hidden-sm-and-down">
      <el-row :gutter="20">
        <div v-for="(num, index) in numeros" :key="index">
          <el-col :md="8">
            <el-col :md="10" style="text-align: center">
              <img class="img_numeros" :src="num.icon" alt="Ejemplo" />
            </el-col>
            <el-col :md="12" :offset="1">
              <div class="texto_num">
                <el-row
                  ><h2 class="titulo_nos">
                    <span v-if="num.texto === 'numeros.titulo_c'">+</span>
                    <ICountUp ref="countUp" ref-in-for :delay="delay" :endVal="$t(num.valor)" :options="options" @ready="onReady" /></h2
                ></el-row>
                <p class="subtitulo_numeros" v-html="$t(num.texto)"></p>
              </div>
            </el-col>
          </el-col>
        </div>
      </el-row>
      <div style="padding: 2% 0px"></div>

      <el-row :gutter="20">
        <div v-for="(num, index) in numeros2" :key="index">
          <div v-if="num.texto == 'numeros.titulo_d'">
            <el-col :md="12" :sm="12" :xs="10">
              <el-row :gutter="20" class="padding-img-l" style="float: right">
                <el-col :md="10" style="text-align: center">
                  <!-- <img class="img_numeros" :src="num.icon" alt="Ejemplo" /> -->
                  <!-- {{ num.texto == 'numeros.centros' }} -->
                  <img class="img_numeros2" :src="num.icon" alt="Ejemplo" />
                </el-col>
                <el-col :md="12" :offset="1">
                  <div class="texto_num">
                    <el-row
                      ><h2 class="titulo_nos">
                        <ICountUp ref="countUp" ref-in-for :delay="delay" :endVal="$t(num.valor)" :options="options" @ready="onReady" /></h2
                    ></el-row>

                    <p class="subtitulo_numeros" v-html="$t(num.texto)"></p>
                  </div>
                </el-col>
              </el-row>
            </el-col>
          </div>
          <div v-if="num.texto == 'numeros.titulo_dis'">
            <el-col :md="12" :sm="12" :xs="10">
              <el-row :gutter="20">
                <el-col :md="10" style="text-align: center">
                  <!-- <img class="img_numeros" :src="num.icon" alt="Ejemplo" /> -->
                  <!-- {{ num.texto == 'numeros.centros' }} -->
                  <img class="img_numeros3" :src="num.icon" alt="Ejemplo" />
                </el-col>
                <el-col :md="12" :offset="1">
                  <div class="texto_num">
                    <el-row
                      ><h2 class="titulo_nos p-margin-left">
                        <span v-if="num.texto === 'numeros.titulo_c'">+</span>
                        <ICountUp ref="countUp" ref-in-for :delay="delay" :endVal="$t(num.valor)" :options="options" @ready="onReady" /></h2
                    ></el-row>

                    <p class="subtitulo_numeros p-margin-left" v-html="$t(num.texto)"></p>
                  </div>
                </el-col>
              </el-row>
            </el-col>
          </div>
        </div>
      </el-row>
    </div>
    <div class="hidden-md-and-up">
      <el-row>
        <div v-for="(num, index) in numeros" :key="index">
          <el-col :md="12" :sm="12" :xs="10">
            <img class="img-cel" :src="num.icon" alt="Ejemplo" />
          </el-col>
          <el-col :sm="12" :xs="10">
            <div class="texto_num" style="padding-bottom: 15%; margin-right: 20%">
              <el-row
                ><h2>
                  <span v-if="num.texto === 'numeros.titulo_c'">+</span>
                  <ICountUp ref="countUp" ref-in-for :delay="delay" :endVal="$t(num.valor)" :options="options" @ready="onReady" /></h2
              ></el-row>
              <p class="subtitulo_numeros" v-html="$t(num.texto)"></p>
            </div>
          </el-col>
        </div>
      </el-row>
      <el-row>
        <div v-for="(num, index) in numeros2" :key="index">
          <el-col :sm="12" :xs="10">
            <!-- <img v-if="num.valor == 'numeros.centros'" style="margin-top: 3px; margin-left: 30%; width: 50%; padding-bottom: 5%" :src="num.icon" alt="Ejemplo" /> -->
            <img class="img-cel" :src="num.icon" alt="Ejemplo" />
          </el-col>
          <el-col :sm="12" :xs="10">
            <div class="texto_num" style="padding-bottom: 15%; margin-right: 20%">
              <el-row
                ><h2>
                  <span v-if="num.texto === 'numeros.titulo_c'">+</span>
                  <ICountUp ref="countUp" ref-in-for :delay="delay" :endVal="$t(num.valor)" :options="options" @ready="onReady" /></h2
              ></el-row>
              <p class="subtitulo_numeros" v-html="$t(num.texto)"></p>
            </div>
          </el-col>
        </div>
      </el-row>
    </div>
  </div>
</template>
<script>
import accounting from 'accounting'
import ICountUp from 'vue-countup-v2'
import AOS from 'aos'
import 'aos/dist/aos.css'

export default {
  components: { ICountUp },

  data() {
    return {
      delay: 1000,
      options: {
        useEasing: true,
        useGrouping: true,
        separator: '.',
        decimal: ',',
      },
      observer: null,
      countupInstances: [],
      numeros: [
        { icon: require('@/assets/iconos/00_Datos - ICONO.png'), valor: 'numeros.posiciones', texto: 'numeros.titulo_p' },
        { icon: require('@/assets/iconos/01_Datos - ICONO.png'), valor: 'numeros.colaboradores', texto: 'numeros.titulo_c' },
        { icon: require('@/assets/iconos/02_Datos - ICONO.png'), valor: 'numeros.m2', texto: 'numeros.titulo_m' },
      ],
      numeros2: [
        // { icon: require('@/assets/iconos/03_Datos - ICONO.png'), valor: 'numeros.unidades', texto: 'numeros.titulo_u' },
        { icon: require('@/assets/iconos/04_Datos - ICONO.png'), valor: 'numeros.docks', texto: 'numeros.titulo_d' },
        { icon: require('@/assets/iconos/05_Datos - ICONO.png'), valor: 'numeros.centros', texto: 'numeros.titulo_dis' },
      ],
    }
  },

  mounted() {
    AOS.init({
      duration: 1000,
      offset: 100,
      once: false, // false = animaciones se repiten al volver a scrollear
    })

    this.observer = new IntersectionObserver(this.handleIntersect, { threshold: 0.5 })
    this.$nextTick(() => {
      const countUps = this.$refs.countUp
      const elements = Array.isArray(countUps) ? countUps : [countUps]
      elements.forEach((el) => el.$el && this.observer.observe(el.$el))
    })
  },

  beforeDestroy() {
    if (this.observer) this.observer.disconnect()
  },

  methods: {
    formatoMoneda(value) {
      return accounting.formatMoney(value, '', 0)
    },

    onReady(instance) {
      this.countupInstances.push(instance)
    },
    handleIntersect(entries) {
      entries.forEach((entry) => {
        const instance = this.countupInstances.find((inst) => inst.el === entry.target)
        if (!instance) return
        if (entry.isIntersecting) {
          instance.reset()
          instance.start()
        } else {
          instance.reset() // opcional
        }
      })
    },
  },
}
</script>
<style>
/* PRUEBA */
.stats {
  display: grid;
  grid-template-columns: repeat(6, 1fr);
  gap: 60px 40px;
  /* background: #eee; */
  padding: 80px 40px;
  text-align: center;
}

.stat {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.stat img {
  width: 60px;
  margin-bottom: 20px;
}

.stat h2 {
  color: #d35400;
  font-size: 48px;
  margin: 0;
}

.stat p {
  color: #d35400;
  font-weight: 500;
  margin-top: 10px;
  line-height: 1.4;
}

/* --- Posicionamiento --- */

/* Fila superior */
.top-left {
  grid-column: 1 / 3;
}

.top-center {
  grid-column: 3 / 5;
}

.top-right {
  grid-column: 5 / 7;
}

/* Fila inferior (desplazados 1 columna) */
.bottom-left {
  grid-column: 2 / 4;
}

.bottom-right {
  grid-column: 4 / 6;
}
/* -------- */
.card-centrada {
  display: flex;
  justify-content: center; /* Centra horizontalmente todo el bloque */
  align-items: center; /* Centra verticalmente dentro del card */
  height: 100%; /* Ajustar según el alto de la tarjeta */
  text-align: center;
  border: 0px !important;
}

.contenido-centrado {
  display: flex;
  align-items: center; /* Alinea verticalmente la imagen con el texto */
  justify-content: center; /* Centra ambos dentro del card */
  gap: 1.5rem; /* Espacio entre imagen y texto */
}

.texto_num h2 {
  color: #d35400; /* Mismo color que en tu ejemplo */
  margin: 0;
  /* font-weight: 700; */
  font-family: 'roboto-black';
  text-align: left;
}

.texto_num p {
  color: #d35400;
  /* font-size: 0.9rem; */
  margin: 0;
  text-align: left;
  font-family: 'roboto-regular';
  /* letter-spacing: 1.3px; */
  line-height: 1.5;
}
.img-style {
  width: 25%;
  /* float: inline-end; */
  text-align: center;
}
.subtitulo_numeros {
  margin-top: -40px;
  font-family: 'roboto-regular';
}
.bg-nosotros-numeros {
  background-color: #d35915;
  position: relative;
  z-index: 999;
  padding: 5% 5% 5% 5%;
}
.texto_num h2 {
  color: #d35400; /* Mismo color que en tu ejemplo */
  margin: 0;
  /* font-weight: 700; */
  font-family: 'roboto-black';
}
.texto_num p {
  color: #d35400;
  margin: 0;
  font-family: 'roboto-regular';
  width: 120%;
}
.img_numeros {
  width: 32%;
  text-align: center;
  margin-top: 5%;
  margin-left: 75%;
}
.img_numeros3 {
  width: 23%;
  text-align: center;
  margin-top: 5%;
  /* margin-left: 49%; */
  margin-left: 57%;
}
.img_numeros2 {
  width: 32%;
  text-align: center;
  margin-top: 5%;
  margin-left: 75%;
}
.p-margin-left {
  margin-left: -15% !important;
}
@media (min-width: 2561px) {
  .contenido-centrado img {
    width: 90px; /* Ajustá el tamaño según tu diseño */
    height: auto;
  }
  .bg-nosotros-numeros {
    background-color: #d35915;
    position: relative;
    z-index: 999;
    padding: 7% 2% 7% 2%;
  }
  .subtitulo_numeros {
    font-size: 23px;
  }
  .texto_num p {
    color: #d35400;
    margin: 0;
    text-align: left;
    font-family: 'roboto-regular';
  }
  .padding-img-r {
    /* padding-right: 30%; */
    margin-left: -12% !important;
  }
  .padding-img-l {
    /* padding-left: 25%; */
    padding-left: 5%;
  }
}
@media screen and (min-width: 1920px) and (max-width: 2560px) {
  /* .espacio {
    padding: 0px 3% 0px 5%;
  }
  .espacio-abajo {
    padding: 0px 0px 0px 7%;
  } */

  .contenido-centrado img {
    width: 90px; /* Ajustá el tamaño según tu diseño */
    height: auto;
  }
  .bg-nosotros-numeros {
    background-color: #d35915;
    position: relative;
    z-index: 999;
    padding: 7% 2% 7% 2%;
  }
  .subtitulo_numeros {
    font-size: 23px;
  }
}
@media screen and (min-width: 1440px) and (max-width: 1919px) {
  .contenido-centrado img {
    width: 95px; /* Ajustá el tamaño según tu diseño */
    height: auto;
  }
  .subtitulo_numeros {
    font-size: 21px;
  }
  .img_numeros {
    width: 34%;
    text-align: center;
    margin-top: 5%;
    margin-left: 60%;
  }
  .img_numeros2 {
    width: 25.2%;
    text-align: center;
    margin-top: 5%;
    margin-left: 75.2%;
  }
  .img_numeros3 {
    width: 22%;
    text-align: center;
    margin-top: 5%;
    margin-left: 42%;
  }
}
@media screen and (min-width: 1023px) and (max-width: 1439px) {
  .contenido-centrado img {
    width: 90px; /* Ajustá el tamaño según tu diseño */
    height: auto;
  }
  .subtitulo_numeros {
    font-size: 19px;
  }
  .img_numeros {
    width: 40%;
    margin-left: 60%;
  }
  .img_numeros2 {
    width: 25.5%;
    text-align: center;
    margin-top: 5%;
    margin-left: 78%;
  }
  .img_numeros3 {
    width: 26%;
    text-align: center;
    margin-top: 5%;
    margin-left: 45%;
  }
}
@media screen and (min-width: 768px) and (max-width: 1024px) {
  .bg-nosotros-numeros {
    background-color: #d35915;
    position: relative;
    z-index: 999;
    padding: 12% 10% 12% 10%;
  }
  .texto_num h2,
  .texto_num p {
    text-align: left !important;
  }
  .contenido-centrado img {
    width: 70px; /* Ajustá el tamaño según tu diseño */
    height: auto;
  }
  .subtitulo_numeros {
    font-size: 15px !important;
    text-align: left;
  }
  .titulo_nos {
    font-size: 40px;
  }
  .img_numeros {
    width: 80%;
    text-align: center;
    margin-left: -50px;
  }
  .img_numeros2 {
    width: 50%;
    text-align: center;
    margin-top: 5%;
    margin-left: 40px;
  }
  .img_numeros3 {
    width: 50%;
    text-align: center;
    margin-top: 5%;
    margin-left: 40px;
  }
  .img-cel {
    margin-top: 3px;
    margin-left: 60% !important;
    width: 30% !important;
    padding-bottom: 5%;
  }
}
@media (orientation: landscape) and (max-height: 500px) {
  .heigh-contenedor,
  .promo .image-wrapper {
    height: 60vh !important;
  }
  .bg-nosotros-2 {
    padding: 10% 10% 10% 10% !important;
  }
  .img-cel {
    margin-top: 3px;
    margin-left: 60% !important;
    width: 30% !important;
    padding-bottom: 5%;
  }
  .texto_num {
    margin-right: 50% !important;
    /* text-align: right !important; */
  }
  .texto_num h2 {
    margin-top: -8px;
  }

  .texto_num h2,
  .texto_num p {
    text-align: left !important;
    font-size: 2.5rem;
  }
  .subtitulo_numeros {
    font-size: 20px !important;
    text-align: left;
  }
  .bg-nosotros-numeros {
    padding: 10% 10% 10% 10%;
  }
}
@media screen and (min-width: 375px) and (max-width: 767px) {
  .bg-nosotros-numeros {
    background-color: #d35915;
    position: relative;
    z-index: 999;
    padding: 12% 10% 12% 10%;
  }
  .subtitulo_numeros {
    font-size: 17px !important;
  }
  .contenido-centrado img {
    width: 80px; /* Ajustá el tamaño según tu diseño */
    height: auto;
  }
  .texto_num p {
    width: 100%;
  }
  .texto_num h2,
  .texto_num p,
  .titulo_nos {
    text-align: left !important;
  }
  .img-cel {
    margin-top: 3px;
    margin-left: 40%;
    width: 40%;
    padding-bottom: 5%;
  }
}
@media (max-width: 375px) {
  .bg-nosotros-numeros {
    background-color: #d35915;
    position: relative;
    z-index: 999;
    padding: 12% 10% 12% 10%;
  }
  .subtitulo_numeros {
    font-size: 17px !important;
  }
  .contenido-centrado img {
    width: 70%;
    height: auto;
  }
  .texto_num p {
    width: 100%;
  }
  .texto_num h2,
  .texto_num p,
  .titulo_nos {
    text-align: left !important;
  }
  .img-cel {
    margin-top: 3px;
    margin-left: 40%;
    width: 40%;
    padding-bottom: 5%;
  }
}
</style>
